import { render, staticRenderFns } from "./EndorseDialog.vue?vue&type=template&id=8d5098d8&scoped=true&"
import script from "./EndorseDialog.vue?vue&type=script&lang=js&"
export * from "./EndorseDialog.vue?vue&type=script&lang=js&"
import style0 from "./EndorseDialog.vue?vue&type=style&index=0&id=8d5098d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d5098d8",
  null
  
)

export default component.exports